/**
 * Departments, and the workspaces they own (WALLIYO-0132).
 *
 * A department owns roles. A role belongs to one department, and that is the
 * workspace its holders land in. The workspace is never derived from the
 * features a role grants: an Engineer holds VIEW_ACCOUNTS, VIEW_PAYMENTS and
 * VIEW_AUDIT_LOG, so derivation would put them in Support, Finance and
 * Administration and never in Engineering.
 *
 * What a workspace lists is a superset, not a promise. Every screen still
 * checks its own feature, so a Product Manager and a Software Engineer share
 * one workspace and see almost different consoles.
 */

/** The departments Walliyo is run by. `legal` has no workspace yet. */
export const DEPARTMENT_IDS = [
  "executive",
  "marketplace",
  "support",
  "trust",
  "finance",
  "growth",
  "product",
  "people",
  "administration",
  "legal",
] as const;

export type DepartmentId = (typeof DEPARTMENT_IDS)[number];

export type Department = {
  id: DepartmentId;
  /**
   * The workspace's screens, in the order its sidebar draws them. Empty for a
   * department that runs the company without a console of its own.
   */
  screens: readonly string[];
  /**
   * False while a department exists on the org chart and has nothing to open.
   * It is still a department: people belong to it, and roles can name it.
   */
  hasWorkspace: boolean;
};
